import {
    buildUrl,
    formatParam,
} from "../util/integration";

import {
    authorizedFetch,
} from "./http_api";


const paymentStripeUrl = (
    userId,
    resource = "",
) => {
    const suffix = resource
        ? `/${resource}`
        : "";

    return buildUrl(
        `payment_stripe/user/${formatParam(userId)}`
        + suffix,
    );
};


const authorizedPaymentStripeRequest = (
    userId,
    accessToken,
    resource = "",
    method = "GET",
) => {
    return authorizedFetch(
        accessToken,
        paymentStripeUrl(
            userId,
            resource,
        ),
        {
            method,
        },
    );
};


/*
 * GET
 * /payment_stripe/user/{userId}/onboarding/ready
 */
export const fetchStripeReadyAPI = (
    userId,
    accessToken,
) => {
    return authorizedPaymentStripeRequest(
        userId,
        accessToken,
        "onboarding/ready",
    );
};


/*
 * GET
 * /payment_stripe/user/{userId}/onboarding/can_receive
 *
 * Dieser Endpoint benötigt laut Backend
 * keinen Authorization-Header.
 */
export const fetchStripeCanReceiveAPI = (
    userId,
) => {
    return fetch(
        paymentStripeUrl(
            userId,
            "onboarding/can_receive",
        ),
    );
};


/*
 * POST
 * /payment_stripe/user/{userId}/onboarding
 */
export const startStripeOnboardingAPI = (
    userId,
    accessToken,
) => {
    return authorizedPaymentStripeRequest(
        userId,
        accessToken,
        "onboarding",
        "POST",
    );
};


/*
 * GET
 * /payment_stripe/user/{userId}/onboarding/refresh
 */
export const refreshStripeOnboardingAPI = (
    userId,
    accessToken,
) => {
    return authorizedPaymentStripeRequest(
        userId,
        accessToken,
        "onboarding/refresh",
    );
};


/*
 * DELETE
 * /payment_stripe/user/{userId}/onboarding
 */
export const clearStripeOnboardingAPI = (
    userId,
    accessToken,
) => {
    return authorizedPaymentStripeRequest(
        userId,
        accessToken,
        "onboarding",
        "DELETE",
    );
};